import React, { useState, useEffect } from "react";
import { useAuth } from "./AuthProvider";

const ClusterSelector = ({ onSelectCluster }) => {
  const { isLoggedIn, token } = useAuth();
  const [clusters, setClusters] = useState([]);
  const [selectedClusterId, setSelectedClusterId] = useState("");

  useEffect(() => {
    const fetchClusters = async () => {
      if (!isLoggedIn || !token) return;

      try {
        const res = await fetch("/api/my-clusters", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!res.ok) {
          const errorText = await res.text();
          console.error("Gagal mengambil cluster:", errorText);
          return;
        }

        const data = await res.json();
        setClusters(data);

        if (data.length > 0) {
          const defaultCluster = data[0];
          setSelectedClusterId(defaultCluster.id.toString());
          onSelectCluster(defaultCluster);
        }
      } catch (err) {
        console.error("Error saat fetch cluster:", err);
      }
    };

    fetchClusters();
  }, [isLoggedIn, token]);

  const handleChange = (e) => {
    const clusterId = e.target.value;
    setSelectedClusterId(clusterId);

    const selected = clusters.find((c) => c.id.toString() === clusterId);
    if (selected && onSelectCluster) {
      onSelectCluster(selected);
    }
  };

  if (!isLoggedIn) {
    return (
      <div className="text-sm text-gray-500 italic px-2 py-1">
        Personal Cluster aktif (Anonymous Mode)
      </div>
    );
  }

  return (
    <div className="flex items-center space-x-2">
      <select
        value={selectedClusterId}
        onChange={handleChange}
        className="border border-gray-600 bg-gray-900 text-gray-200 rounded px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500"
      >
        <option value="" disabled>Select a cluster</option>
        {clusters.map((cluster) => (
          <option key={cluster.id} value={cluster.id.toString()}>
            {cluster.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default ClusterSelector;
